export default __webpack_public_path__ + "static/media/formazionelattes-logo-nc.63fded9a.png";